import React from "react";

interface TokenPaymentIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

export const TokenPaymentIcon: React.FC<TokenPaymentIconProps> = ({
  size = 60,
  className,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Circle Background */}
      <circle
        cx="30"
        cy="30"
        r="29"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />

      {/* Check Icon */}
      <path
        d="M22 30L27 35L38 24"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};